import _ from "lodash";
import { persistLitigationSubEntities } from "./AbstractLitigationCasePersister";
import { getUpdateData, persistAddress, persistPerson, trimValueIfSet } from "./persisterService";
import ApiClient from "../ApiClient";
import { Organization } from "../../types/Organization";
import { UseForm } from "../../types/UseForm";
import { ContractUnion } from "../../types/ContractUnion";

export const persistContractClaimSubEntities = async (
  updateData: UseForm["values"],
  origContractClaim: ContractUnion
) => {
  await persistLitigationSubEntities(updateData, origContractClaim);

  if (_.isObject(updateData.contractualPartnerPerson)) {
    const contractualPartnerPersonUpdateData = getUpdateData(
      updateData.contractualPartnerPerson,
      origContractClaim,
      "contractualPartnerPerson"
    );
    await persistPerson(origContractClaim.contractualPartnerPerson.id, contractualPartnerPersonUpdateData);
  }

  if (
    _.has(updateData, "contractualPartnerPerson.residenceAddress") &&
    _.isObject(updateData.contractualPartnerPerson.residenceAddress)
  ) {
    const contractualPartnerPersonAddressUpdateData = getUpdateData(
      updateData.contractualPartnerPerson.residenceAddress,
      origContractClaim,
      "contractualPartnerPerson.residenceAddress"
    );
    await persistAddress(
      origContractClaim.contractualPartnerPerson.residenceAddress.id,
      contractualPartnerPersonAddressUpdateData
    );
  }

  if (_.isObject(updateData.contractualPartnerLegalEntity?.organization)) {
    const legalEntity: Partial<Organization> = updateData.contractualPartnerLegalEntity.organization;

    let legalEntityUpdateData = getUpdateData(
      legalEntity,
      origContractClaim,
      "contractualPartnerLegalEntity.organization"
    );

    legalEntityUpdateData.additionalRepresentatives = legalEntity.additionalRepresentatives;

    await ApiClient.patch(`organizations/${origContractClaim.contractualPartnerLegalEntity.organization.id}`, {
      body: JSON.stringify(sanitizeContractualPartnerData(legalEntityUpdateData)),
    });
  }

  if (
    _.has(updateData, "contractualPartnerLegalEntity.organization.address") &&
    _.isObject(updateData.contractualPartnerLegalEntity?.organization?.address)
  ) {
    const entityAddress = getUpdateData(
      updateData.contractualPartnerLegalEntity.organization.address,
      origContractClaim,
      "contractualPartnerLegalEntity.organization.address"
    );

    await persistAddress(origContractClaim.contractualPartnerLegalEntity.organization.address.id, entityAddress);
  }
};

const sanitizeContractualPartnerData = (contractualPartner: Partial<Organization>) => {
  let sanitizedContractualPartnerData = _.cloneDeep(contractualPartner);
  sanitizedContractualPartnerData = trimValueIfSet("name", sanitizedContractualPartnerData);
  sanitizedContractualPartnerData = trimValueIfSet("streetAddress", sanitizedContractualPartnerData);
  sanitizedContractualPartnerData = trimValueIfSet("postalCode", sanitizedContractualPartnerData);
  sanitizedContractualPartnerData = trimValueIfSet("addressLocality", sanitizedContractualPartnerData);
  return sanitizedContractualPartnerData;
};
